import { isUserHasAnyRole, userRoleKeys } from './rolesHelper';

export const isPigPulseAvailable = (user) => {
  if (!user || !user.current_company || !user.current_company.pigpulse) return false;
  return isUserHasAnyRole(user, [userRoleKeys.super_admin, userRoleKeys.admin, userRoleKeys.tenant_owner]);
};
